import React from "react";
import { useDataContext } from "UIDataHandler";
import {goToPCareMenu, useKeyMap} from "KeyboardEventHelper";
import {Button, Icon} from "./index.js";
import IconTypeEnum from "Enum/IconTypeEnum";
import constants from "Constants";
import {SyncLoader} from "react-spinners";

const ActionBar = ({ questionData, className='' }) => {
    const {
        currentQuestionIndex,
        goToNextQuestion,
        goToPreviousQuestion,
        currentQuestion,
        numQuestions,
        surveyData,
        form,
        setForm,
        isSubmitting,
        controllerMode
    } = useDataContext();

    const [isFirst, setIsFirst] = React.useState(currentQuestionIndex === 0);
    const [isLast, setIsLast] = React.useState(currentQuestionIndex === numQuestions - 1);
    const [showSkipButton, setShowSkipButton] = React.useState(false);
    const [nextButtonDisabled, setNextButtonDisabled] = React.useState(false);

    const isNa = currentQuestion.includeNa && form.answers[currentQuestionIndex].isNa;

    const updateNextButtonDisabledState = () => {
        if (currentQuestion) {
            setNextButtonDisabled(
                currentQuestion.includeNs === false &&
                (!form.answers[currentQuestionIndex].answer && !form.answers[currentQuestionIndex].isNs && !isNa)
            );
        }
    };

    const getHasTempAnswer = () => {
        return !!form.answers[currentQuestionIndex].answer || form.answers[currentQuestionIndex].isNa;
    }

    const skipQuestion = () => {
        form.answers[currentQuestionIndex] = {
            question: surveyData.questions[currentQuestionIndex].id,
            answer: '',
            isNs: true,
            isNa: false
        };
        setForm({...form});
    }

    const handleSkipButton = () => {
        skipQuestion();
        goToNextQuestion();
    };

    const useHandleSubmit = () => {
        if (showSkipButton && !getHasTempAnswer()) {
            skipQuestion();
        }
        goToNextQuestion();
    }

    React.useEffect(() => {
        setIsFirst(currentQuestionIndex === 0);
        setIsLast(currentQuestionIndex === numQuestions - 1);
        updateNextButtonDisabledState();
        setShowSkipButton(questionData.includeNs === true);
    }, [questionData]);

    React.useEffect(() => {
        updateNextButtonDisabledState();
    }, [form]);

    let keyMap = {}
    if (controllerMode) {
        if (!isFirst) {
            keyMap['ArrowLeft'] = () => goToPreviousQuestion()
        }
        if (!isSubmitting && showSkipButton) {
            keyMap['ArrowRight'] = () => handleSkipButton()
        }
    }
    useKeyMap(keyMap);

    return <div id={'feedback-action-bar'} className={`flex-none flex flex-row justify-between`}>
        <div onClick={goToPreviousQuestion} className={`flex-1 text-left`}>{ !isFirst
            ? controllerMode
                ? <Icon type={IconTypeEnum.BACK} size={25} />
                : <Button type={`standard`} className={`flex-none`}>{'Back'}</Button>
            : <></>
        }</div>
        <div onClick={handleSkipButton} className={`shrink-0 flex items-center`}>{ showSkipButton
            ? controllerMode
                ? <Icon type={IconTypeEnum.NEXT} size={25} />
                : <Button type={`link`} className={`flex-none bg-transparent skip-button color1-text`}>Skip{isLast ? ' & Submit' : ''}</Button>
            : <></>
        }</div>
        <div className={`flex flex-row flex-1 justify-end`}>
            { !controllerMode && <Button
                    onClick={isLast ? useHandleSubmit : (showSkipButton && !getHasTempAnswer()) ? handleSkipButton : goToNextQuestion }
                    type={isLast ? `special` : `standard`}
                    className={`flex-none`}
                    disabled={nextButtonDisabled || isSubmitting}
                >
                    {isLast ? 'Finish' : 'Next'}
                </Button>
            }
            <div
                onClick={() => controllerMode ? goToPCareMenu() : window.location.reload()}
                className={`text-base flex items-center md:flex md:flex-row md:gap-[10px] hover:cursor-pointer ml-10 mr-5 color1-text exit-button`}
            >
                { controllerMode
                    ? <>Press <Icon type={IconTypeEnum.MENU} size={25} /> to Quit</>
                    : <>
                        <Icon type={IconTypeEnum.EXIT} size={25}/>
                        <span className={'hidden md:block'}>Exit</span>
                    </>
                }
            </div>
        </div>
    </div>;
};

export default ActionBar;
